<div class="inner-page-wrapper pt-24 md:py-40">
    <h2 class="font-headline text-34 mb-24 text-center leading-41 font-medium text-black md:mb-64">
        {{ faq().headline }}
    </h2>

    @for (item of faq().questions; track item.id) {
        @let answer = item.answer?.html ?? '' | footnotes;
        @let question = item.question ?? '' | footnotes;

        @if (answer() && question()) {
            <details class="group" [id]="question()" [open]="question() === initialOpenSlug()">
                <summary
                    class="border-grey-200 flex w-full cursor-pointer items-center justify-between border-b-2 py-24 pr-16 pl-24"
                >
                    <div
                        class="font-headline text-18 md:text-22 md:text-accent leading-27 font-medium text-black md:leading-28"
                        [innerHTML]="question()"
                    ></div>

                    <i
                        class="icon-chevron-down text-16 text-accent transition-all group-open:rotate-180"
                        aria-hidden="true"
                    ></i>
                </summary>

                <div
                    class="border-grey-200 group-open:animate-show [&_a]:text-accent border-b-2 px-24 py-16 md:p-40 [&_a]:underline [&_ul]:list-disc [&_ul]:pl-24 [&_ul]:leading-32"
                >
                    @defer (on idle; hydrate on viewport) {
                        <div [innerHTML]="answer()" text></div>
                    }
                </div>
            </details>
        }
    }
</div>
